import { render, staticRenderFns } from "./PublicAlbum.vue?vue&type=template&id=424daf7e&"
import script from "./PublicAlbum.vue?vue&type=script&lang=js&"
export * from "./PublicAlbum.vue?vue&type=script&lang=js&"
import style0 from "./PublicAlbum.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports